<template>
  <div class="login-page">
    <div class="login-box">
      <div class="left"></div>
      <div class="right">
        <div class="title">
            AI智能火点精准监管系统平台
        </div>
        <el-form :model="form" :rules="rules" ref="form" label-width="0px" class="demo-ruleForm">
          <el-form-item prop="username">
            <div class="input-box">
              <div class="label">账号</div>
              <el-input style="width: 420px" v-model="form.username" placeholder="请输入内容"></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="input-box">
              <div class="label">密码</div>
              <el-input show-password style="width: 420px" v-model="form.password" placeholder="请输入内容"></el-input>
            </div>
          </el-form-item>
        </el-form>
        <div class="submit" @click="submit">
          登录
        </div>
        <div class="tip">
          <p>主办单位：廊坊市生态环境局安次分局</p>
          <p>技术支持：冠英股份</p>
        </div>
      </div>
    </div>
    <Dialog :show-foot="false" title="发现新版本" :background-image="require('../../assets/login/update-box.png')"
            v-if="showUpdate" width="600px" @close="handleUpdateV(1)">
      <div class="update-info scroll-y">
        <div class="list">
          1.优化了部分体验
        </div>
        <div>
          2.修复若干BUG
        </div>
      </div>
      <div class="update-foot">
        <div class="skip" @click="handleUpdateV(2)">跳过此版本</div>
        <div class="box2" @click="handleUpdateV(1)">暂不更新</div>
        <div class="box4" @click="handleUpdateV(0)">立即更新</div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "../../components/Dialog/index"
import { checkUpdate, updateVersion } from "../../api/set";
import store from "../../store/store";

export default {
  name: "index",
  components: { Dialog },
  data() {
    return {
      showUpdate: false,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],

      }
    }
  },
  methods: {
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.dispatch('systemLogin', this.form).then(() => {
            store.commit('SET_USERINFO', JSON.parse(localStorage.getItem('userInfo')))
            this.checkUpdate()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    checkUpdate () {
      checkUpdate().then(res => {
        if (res.data) {
          this.showUpdate = true
        } else {
          this.$message.success('登录成功！正在跳转...')
          setTimeout(() => {
            this.$router.push({name: 'home'})
          },500)
        }
      })
    },
    handleUpdateV (i) {
      if (i === 0) {
        updateVersion({option: i}).then(() => {
          this.showUpdate = false
          this.$message.success('登录成功！正在跳转...')
          setTimeout(() => {
            this.$router.push({name: 'home'})
          },500)
        })
      }
      updateVersion({option: i} ).then(() => {
        this.showUpdate = false
        this.$message.success('登录成功！正在跳转...')
        setTimeout(() => {
          this.$router.push({name: 'home'})
        },500)
      })
    }
  }
}
</script>

<style scoped lang="less">
.login-page{
  width: 100vw;
  height: 100vh;
  background-image: url("../../assets/login/Rectangle.png");
  background-size: 100% 100%;
  .login-box{
    width: 1300px;
    height: 700px;
    display: grid;
    position: fixed;
    top:50%;
    left: 50%;
    transform: translate(-50%, -50%);
    grid-template-columns: 650px 1fr;
    .left{
      background-image: url("../../assets/login/login-left.png");
      background-size: 100% 100%;
    }
    .right{
      background-color: #FFFFFF;
      padding: 80px 80px 20px 80px;
      border-radius: 0px 10px 10px 0px;
      .title{
        color: #000000;
        font-size: 32px;
        font-weight: bold;
        font-style: italic;
        line-height: 60px;
        padding-bottom: 40px;
        &:after{
          content: '';
          width: 80px;
          height: 4px;
          background-color: #409EFF;
          display: block;
        }
      }
      .input-box{
        .label{
          color: #999999;
          font-size: 16px;
          line-height: 40px;
        }
      }
      .submit{
        width: 420px;
        height: 42px;
        font-size: 20px;
        text-align: center;
        line-height: 42px;
        background-color: #409EFF;
        box-shadow: 0px 4px 10px 0px rgba(4,108,215,0.5000);
        border-radius: 4px 4px 4px 4px;
        margin-top: 80px;
        color: #FFFFFF;
        font-weight: 500;
        cursor: pointer;
      }
      .tip {
        color: #666666;
        font-size: 18px;
        margin-top: 80px;
      }
    }
  }
  .bottom{
    position: fixed;
    bottom: 50px;
    width: 100vw;
    text-align: center;
    color: #FFFFFF;
  }
}
.update-info{
  height: 200px;
  color: #FFFFFF;
  font-size: 18px;
  padding: 30px 30px;
  .list{
    padding: 20px 0px;
  }
}
.update-foot{
  height: 55px;
  display: flex;
  justify-content: center;
  padding-top: 5px;
  align-items: center;
  div{
    width: 160px;
    height: 50px;
    background-size: 100% 100%;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    cursor: pointer;
  }
  .box2{
    background-image: url("../../assets/img/box2.png");
    color: #00FFF6;
  }
  .box4 {
    background-image: url("../../assets/img/box4.png");
    color: #00B2FF;
  }
  .skip{
    background-image: url("../../assets/login/skip.png");
    color: #00FFF6;
    height: 40px;
    line-height: 40px;
    margin-right: 3px;
  }
}
</style>
